import { request } from '@/utils/request';
import {
  LocaleParams,
  PaginationParams,
  RequestResponse,
} from '@/utils/request.types';

import {
  MomentsDataType,
  MomentsProps,
} from './moments.types';

export const api = {
  getMoments: (params: PaginationParams & LocaleParams) => request.get<RequestResponse<MomentsProps>>('/moments', {
    params,
    withCredentials: false,
  }, true),
  getMomentsPage: (params: LocaleParams) => request.get<RequestResponse<MomentsDataType>>('/moments-page', {
    params,
    withCredentials: false,
  }, true),
};
